import {Component, OnInit, ViewChild, Inject, OnDestroy} from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { CurrentRouteService } from '../currentRoute.service';
import {ApiService} from "../api_service/api.service";
import {AccountIdService, AccountNameService} from "../account.service";
import {ModelValidators} from '../validators/validators';
//import {MatAccordion} from "@angular/material/expansion";
import {AgencysService} from "../agencys/agencys.service";
import {AccountsService} from "./accounts.service";
import {AccountInterfaceData, AccountInterfacePostData } from '../shared/models/account.model';
import {Observable} from 'rxjs';
import { last,takeLast } from 'rxjs/operators';
import {SnackBarService} from "../snackBar.service";

export interface DialogData {
  name: string;
  slug: string;
  description: string;
  time_zone: string;
}

// type IdxHash = {
//   account_id: string,
//   idx: number
// }

interface IdxHash {
  account_id: string,
  idx: number
}

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent implements OnInit, OnDestroy {

  helps: string[] = [
    "Create seperate accounts.  For agencies create an account for each client.",
    "For organizations create an account for each line of business or cost center",
  ];
  agency_id:string;
  is_table_column_hidden: boolean = true;
  //accounts: AccountModel[] = [];
  accounts:any = []
  accounts_hash:any = {}
  is_edit:boolean = false;
  account_name:string;
  account_description:string;
  account_store_sub:any;
  //account_idx_hash:IdxHash;
  account_idx_hash:any = {};
  is_loading:boolean = false;

  dataSource: MatTableDataSource< AccountInterfaceData>;
  displayedColumns: string[] = ['name','slug','description', 'View', 'Edit', 'Delete', 'star'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public router: Router,
              public route: ActivatedRoute,
              public dialog: MatDialog,
              private currentrouteService: CurrentRouteService,
              private accountidService: AccountIdService,
              private accountnameService: AccountNameService,
              private _apiService: ApiService,
              private accountsService: AccountsService,
              private snackbarService: SnackBarService,
              ) { }


  ngOnInit(): void {

    let query_parms = this.route.snapshot.queryParamMap;
    let agency_name = query_parms.get('agency_name');


    this.snackbarService.announceSackBar('WTF!!!!!!!!!!!!');


    //ensure the account name and id are cleared
    localStorage.removeItem('account_id');
    localStorage.removeItem('account_name');
    this.accountnameService.announceAccountName('');
    this.accountidService.announceAccountId('')
    this.currentrouteService.announceCurrentRoute(this.router.url);
    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id']
      this.loadAccounts(this.agency_id)
      if (agency_name && agency_name=='Default'){
        this.addAgencyDetails()
      }


    }) //end route
  } //end ngOnInit

  loadAccounts(agency_id){

    this.is_loading = true;
    let endpoint = `account/agency/${agency_id}`;
    this.accountsService.getAccounts(endpoint).subscribe(
      (data: AccountInterfaceData[]) => {

        this.accounts = [];
        this.accounts_hash = {};

        //data will be null if 204 error.  Then about returning [] rather than 204
        if (data != null) {
          for (let _i = 0; _i < data.length; _i++) {

            this.accounts_hash[data[_i]['account_id']] = data[_i];
            this.account_idx_hash[data[_i].account_id] = _i;
            let temp = {};
            temp['Id'] = data[_i].account_id;
            temp['name'] = data[_i].name;
            temp['slug'] = data[_i].slug;
            temp['description'] = data[_i].description;
            temp['Delete'] = '';
            temp['Edit'] = '';
            this.accounts.push(temp)
          }
        }
        this.dataSource = new MatTableDataSource(this.accounts);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error:any) => {
        //error@@@@@@@@@@@@@@@@@@@@@@@ Something bad happened; please try again later.
        console.log('accountService getAccounts', error)
        this.is_loading = false;
      },
      () => {
        //onCompleted
        this.is_loading = false;
        console.log('accountService getAccounts completed')
      }
    )
  } //end loadAccounts

  ngOnDestroy(): void {
    //this.store.dispatch(new AccountListActions.StopEdit());
    if (this.account_store_sub) {
      this.account_store_sub.unsubscribe();
    }
  } //end ngOnDestroy

  addAgencyDetails(){


    const config = new MatDialogConfig();
    config.disableClose = true;

    let idx = null;
    let account_object = null;


    const dialogRef = this.dialog.open(AddAgencyDetailsDialog, {
      width: '250px',
      //height: '300px',
      data: {}
    });
    dialogRef.componentInstance.agency_id = this.agency_id;
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'cancel') {
      } else {
        //navigate to self to get rid of query string
        this.router.navigate(['accounts',this.agency_id]);
        // const queryParams: Params = { myParam: 'myNewValue' };
        // this.router.navigate(
        //   [],
        //   {
        //     relativeTo: activatedRoute,
        //     queryParams: queryParams,
        //     queryParamsHandling: 'merge', // remove to replace all query params by provided
        //   });

      }
    });//end dialogRef.afterClosed()

  } //addAgencyDetails

  addAccount(is_edit, account_id){
    this.is_edit = is_edit;
    const config = new MatDialogConfig();
    config.disableClose = true;

    let idx = null;
    let account_object = null;
    if (account_id != null) {
      account_object = this.accounts_hash[account_id];
      idx = this.account_idx_hash[account_id];
    }

    const dialogRef = this.dialog.open(AddAccountDialog, {
      width: '250px',
      //height: '300px',
      data: {account_name: this.account_name, account_description: this.account_description}
    });
    dialogRef.componentInstance.agency_id = this.agency_id;
    dialogRef.componentInstance.is_edit = is_edit;
    dialogRef.componentInstance.account_object = account_object
    dialogRef.componentInstance.idx = idx
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'cancel') {
      } else {
        this.loadAccounts(this.agency_id) //reload table
      }
    });//end dialogRef.afterClosed()
  } //end addAccount

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  } //end applyFilter

  viewData(row) {
    let account_id = row['Id']
    let account_name = row['name']
    //this.accountNameService.announceAccountName(account_name);
    //this.accountServiceBehavior.announceAccount(account_id);
    localStorage.setItem('account_id', account_id);
    localStorage.setItem('account_name', account_name);

    this.accountnameService.announceAccountName(account_name)
    this.accountidService.announceAccountId(account_id)
    this.router.navigate(['/dashboard', this.agency_id, account_id],{ queryParams: { account_name: account_name }}); // { queryParams: { account_name: account_name }}relativeTo: this.route,
  } //end viewData(row)

  getTableRecord(row) {
  } // end getTableRecord( )

  deleteRow(account_id) {

    const dialogRef = this.dialog.open(DeleteAccountRowDialog, {});
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'cancel') {
        //do nothing
      } else {
        const index = this.account_idx_hash[account_id]
        let endpoint = `account/${account_id}`;
        console.log('wow',endpoint)
        //this.loadAccounts(this.agency_id)
        this.accountsService.delete(endpoint).subscribe(x => {
          console.log('DDDDDDDDDDDD',x)
            console.log('DDDDDDDDDDDDcccccc',this.agency_id)
          this.loadAccounts(this.agency_id);
        },(error:any) => {
          console.log('EEEEE',error)
          this.loadAccounts(this.agency_id);
          }
        );
      }


    });//end dialogRef.afterClosed()
  } //deleteRow

} //end AccountsComponent




@Component({
  selector: 'add-agency-details-dialog',
  templateUrl: 'add-agency-details-dialog.html',
  styleUrls: ['./accounts.component.css']
})

export class AddAgencyDetailsDialog implements OnInit {

  myForm: UntypedFormGroup;
  agency_id: string;
  is_edit: boolean;
  title: string
  button_text: string;
  idx: number;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private agencysService: AgencysService,
    public dialogRef: MatDialogRef<AddAccountDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  } //end constructor

  ngOnInit(): void {

    let name = '';
    let description = '';
    let slug = ''
    this.title = "Add Agency Details";
    this.button_text = "Create";

    this.myForm = this.fb.group({
      name: [name, Validators.required]
    })//end myForm

  }//end ngOnInit

  onNoClick(): void {
    this.dialogRef.close('cancel');
  }

  onSubmit() {


    //let data = this.myForm.value;
    //data['agency_id'] = this.agency_id;
    let data = {}
    data['name'] = this.myForm.controls['name'].value;
    let endpoint = `agency/${this.agency_id}`;
    this.dialogRef.close();
    console.log(data)
    this.agencysService.patchAgency(endpoint, data).subscribe(x => {
      this.dialogRef.close(data);
    }); //end post


    //   let data = this.myForm.value;
    //   clone.account_object.name = this.myForm.controls['name'].value;
    //   clone.account_object.description = this.myForm.controls['description'].value;
    //   let account_id = this.account_object['account_id'];
    //   let endpoint = `account/${account_id}`;
    //
    //   this.dialogRef.close(clone.account_object);
    //
    //   this.accountsService.put(endpoint, clone.account_object).subscribe(x => {
    //     this.dialogRef.close(clone.account_object);
    //   }); //end put
    //
    //
    // } //end if-else
  } //end onSubmit

} //end AddAgencyDetailsDialog
















/*---------------------------------------------
Dialog for adding a new account
---------------------------------------------*/

@Component({
  selector: 'add-account-dialog',
  templateUrl: 'add-account-dialog.html',
  styleUrls: ['./accounts.component.css']
})
export class AddAccountDialog implements OnInit {

  timezone_list = [ {'name':'America/Los Angeles','id': 'America/Los_Angeles'},
                    {'name':'America/New York','id': 'America/New_York'},
                    {'name':'UTC','id': 'UTC'}
                  ]

  // remeber to update python valication rules
  currency_list = [
    {'name': 'USD', 'id':"USD"}
  ]

  myForm: UntypedFormGroup;
  agency_id: string;
  is_edit: boolean;
  account_object: AccountInterfaceData;
  title: string
  button_text: string;
  idx: number;

  constructor(
    private fb: UntypedFormBuilder,
    private accountsService: AccountsService,
    public dialogRef: MatDialogRef<AddAccountDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  } //end constructor

  ngOnInit(): void {

    let name = '';
    let description = '';
    let slug = ''
    let time_zone = ''
    this.title = "Create Account";
    this.button_text = "Create";
    if (this.is_edit == true) {
      this.title = "Edit Account";
      this.button_text = "Update";
      name = this.account_object['name'];
      if (this.account_object['slug'] == null) {
        slug = ''
      } else {
        slug = this.account_object['slug'];
      }
      description = this.account_object['description'];
      if (this.account_object['time_zone'] == null) {
        time_zone = ''
      } else {
        time_zone = this.account_object['time_zone'];
      }
    } //end if edit==true

    this.myForm = this.fb.group({
      name: [name, Validators.required],
      slug: [{
        value: slug,
        disabled: this.is_edit
      }, [Validators.required, ModelValidators.onlyAlphaAndLowerCase, ModelValidators.cannotContainSpace]],
      description: [description,Validators.required],
      time_zone: [time_zone, Validators.required],
    })//end myForm

  }//end ngOnInit

  onNoClick(): void {
    this.dialogRef.close('cancel');
  }

  onSubmit() {

    if (this.is_edit == false) {
      let data = this.myForm.value;
      data['agency_id'] = this.agency_id;
      let endpoint = `account/agency/${this.agency_id}`;
      this.dialogRef.close(this.data);
      this.accountsService.post(endpoint, data).subscribe(x => {
        this.dialogRef.close(this.data);
      }); //end post
    } else {
      //https://stackoverflow.com/questions/57591012/ngrx-cannot-assign-to-read-only-property-property-of-object-object
      const clone = {
        account_object: Object.assign({}, this.account_object)
      };

      let data = this.myForm.value;
      clone.account_object.name = this.myForm.controls['name'].value;
      clone.account_object.description = this.myForm.controls['description'].value;
      clone.account_object.time_zone = this.myForm.controls['time_zone'].value;
      let account_id = this.account_object['account_id'];
      let endpoint = `account/${account_id}`;

      this.dialogRef.close(clone.account_object);

      console.log('wtf',clone.account_object)

      this.accountsService.put(endpoint, clone.account_object).subscribe(x => {
        this.dialogRef.close(clone.account_object);
      }); //end put


    } //end if-else
  } //end onSubmit

} //end AddAccountDialog



/*---------------------------------------------
DK To Delete?????
---------------------------------------------*/
@Component({
  selector: 'delete-account-row-dialog',
  templateUrl: 'delete-account-row-dialog.html'
})
export class DeleteAccountRowDialog implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DeleteAccountRowDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  } //end constructor

  ngOnInit(): void {


  }//end ngOnInit

  onNoClick(): void {
    this.dialogRef.close('cancel');
  } //Cancel


} //end AddAccountDialog


















































